import { Component, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResponseBase, ScreenModel, ResponseData,RequestData } from '../../../../core/models/common';
import {
  ContactPerson,
  ContactPersonServerData,
  ManagedContent,
  ManagedContentServerData,
  Organization,
  OrganizationServerData,
  
} from '../../../../core/models/fna';
import { ApiService } from '../../../../core/services/api-mock.service';
import { GlobalsService } from '../../../../core/services/globals.service';
import { MultiStepModalComponent } from '../../components/multi-step-modal/multi-step-modal.component';
import { SharedAPIService } from '../../../../core/services/shared-api.service';
// What we receive from the API when page is loaded
export interface OrganizationInformationData extends ResponseBase {
  Organization: OrganizationServerData;
  ContactPerson: ContactPersonServerData;
  TreasuryAdvisorName: string;
  LastFNADate: string;
  PurposeOfFormContent?: ManagedContentServerData[];
  HasReadPurposeOfFormModal?: boolean;
}

// What we work with in this screen.
export class OrganizationInformationModel extends ScreenModel {
  screenName = 'OrganizationInformation';
  pageID_read = 'R0040';
  pageID_write = 'S0040';
  data: ResponseBase | undefined;
  organization: Organization | undefined;
  contactPerson: ContactPerson | undefined;
  treasuryAdvisorName: string | undefined;
  lastFNADate: string | undefined;
 // purposeOfFormContent?: ManagedContent[] | null;
  hasReadPurposeOfFormModal?: boolean;
  purposeOfFormContent?: ManagedContent[] =[
    {
      "title": "Purpose of this form",
      "body": "<p>The purpose of this form is to gain an understanding of your Organisation’s overall financial situation and future financial needs. The investment advice in this form is based on the information you provide to us. We therefore need you to provide correct and clear answers to all questions and to advise us of any other relevant matters, in order for us to advise you appropriately. If you provide any incorrect or false information it will adversely affect the quality of any investment advice we provide to you. The purpose of this form is to gain an understanding of your Organisation’s overall financial situation and future financial needs. The investment advice in this form is based on the information you provide to us. We therefore need you to provide correct and clear answers to all questions and to advise us of any other relevant matters, in order for us to advise you appropriately. If you provide any incorrect or false information it will adversely affect the quality of any investment advice we provide to you. The purpose of this form is to gain an understanding of your Organisation’s overall financial situation and future financial needs. The investment advice in this form is based on the information you provide to us. We therefore need you to provide correct and clear answers to all questions and to advise us of any other relevant matters, in order for us to advise you appropriately. If you provide any incorrect or false information it will adversely affect the quality of any investment advice we provide to you.</p>"
    },
    {
      "title": "Important notice",
      "body": "<p>The purpose of this form is to gain an understanding of your Organisation’s overall financial situation and future financial needs. The investment advice in this form is based on the information you provide to us. We therefore need you to provide correct and clear answers to all questions and to advise us of any other relevant matters, in order for us to advise you appropriately. If you provide any incorrect or false information it will adversely affect the quality of any investment advice we provide to you. The purpose of this form is to gain an understanding of your Organisation’s overall financial situation and future financial needs. The investment advice in this form is based on the information you provide to us. We therefore need you to provide correct and clear answers to all questions and to advise us of any other relevant matters, in order for us to advise you appropriately. If you provide any incorrect or false information it will adversely affect the quality of any investment advice we provide to you. The purpose of this form is to gain an understanding of your Organisation’s overall financial situation and future financial needs. The investment advice in this form is based on the information you provide to us. We therefore need you to provide correct and clear answers to all questions and to advise us of any other relevant matters, in order for us to advise you appropriately. If you provide any incorrect or false information it will adversely affect the quality of any investment advice we provide to you.</p>"
    },
    {
      "title": "Risk and liabilities",
      "body": "<p>We do not guarantee any returns or investment advice as projected in any financial analysis for any products that we recommend. If you make any investment decision based on any financial analysis or opinion of these products, you accept all risks or losses arising therefrom and will not hold OCBC Bank, its officers, employees or representatives in any way liable. You should read and understand the full Risk Disclosure Statement in Appendix A. We do not guarantee any returns or investment advice as projected in any financial analysis for any products that we recommend. If you make any investment decision based on any financial analysis or opinion of these products, you accept all risks or losses arising therefrom and will not hold OCBC Bank, its officers, employees or representatives in any way liable. You should read and understand the full Risk Disclosure Statement in Appendix A. We do not guarantee any returns or investment advice as projected in any financial analysis for any products that we recommend. If you make any investment decision based on any financial analysis or opinion of these products, you accept all risks or losses arising therefrom and will not hold OCBC Bank, its officers, employees or representatives in any way liable.</p><p> You should read and understand the full <a href=\"./assets/dummy.pdf\" target=\"_blank\">Risk Disclosure Statement</a > in Appendix A.</p>"
    }
  ]
  purposeOfFormContentHTML :string ='';
  riskOfFormContentHTML :string ='';
  noticeOfFormContentHTML :string ='';
  // Data lifecycle start.
  mapPegaObjToUI(data : any){
   console.log("FIRSTEVER MAPPING TEST +++++++")
   console.log(data)
   let customerDetails = data['CustomerDetails']
    let organizationInfoData:OrganizationInformationData  = {
      Organization: {
        CompanyName: customerDetails['Name']?customerDetails['Name']:'-',
        MainAddress: customerDetails['AddressDetails']['FullAddress']?customerDetails['AddressDetails']['FullAddress']:'-',
        TelephoneNo: customerDetails['ContactDetails']['PhoneNumber']?customerDetails['ContactDetails']['PhoneNumber']:'-',
        FaxNo: customerDetails['ContactDetails']['FaxNumber']?customerDetails['ContactDetails']['FaxNumber']:'-',
      },
  ContactPerson: { 
    OrganizationRepresentative:  customerDetails['ContactPersonDetails']['Name']?customerDetails['ContactPersonDetails']['Name']:'-',
    EmailAddress: customerDetails['ContactPersonDetails']['ContactDetails']['EmailAddress']?customerDetails['ContactPersonDetails']['ContactDetails']['EmailAddress']:'-',
    MobileNo: customerDetails['ContactPersonDetails']['ContactDetails']['PhoneNumber']?customerDetails['ContactPersonDetails']['ContactDetails']['PhoneNumber']:'-'
  },
  TreasuryAdvisorName: customerDetails['TreasuryAdvisorName']?customerDetails['TreasuryAdvisorName']:'-',
  LastFNADate: this.getUIDate(customerDetails['DateOfLastFNA'])!=""?this.getUIDate(customerDetails['DateOfLastFNA']):'-',
  PurposeOfFormContent: [],
  HasReadPurposeOfFormModal: true
    }
    return organizationInfoData;
  }

  deriveFromData(data: OrganizationInformationData) {

    
    console.log('deriveFromData, model:', this);
    this.organization = {
      companyName: data.Organization.CompanyName,
      mainAddress: data.Organization.MainAddress,
      telephoneNo: data.Organization.TelephoneNo,
      faxNo: data.Organization.FaxNo,
    };
    this.contactPerson = {
      organizationRepresentative: data.ContactPerson.OrganizationRepresentative,
      emailAddress: data.ContactPerson.EmailAddress,
      mobileNo: data.ContactPerson.MobileNo,
    };
    this.treasuryAdvisorName = data.TreasuryAdvisorName;
    this.lastFNADate = data.LastFNADate;
    // this.purposeOfFormContent = data.PurposeOfFormContent
    //   ? data.PurposeOfFormContent.map((content) => {
    //       return {
    //         title: content.Title,
    //         body: content.Body,
    //       };
    //     })
    //   : null;
    this.purposeOfFormContent = [{
      title: '',
     body: this.purposeOfFormContentHTML,
    },
    {
      title: '',
     body: this.riskOfFormContentHTML,
    },
    {
      title: '',
     body: this.noticeOfFormContentHTML,
    }]
    this.hasReadPurposeOfFormModal = false;
  }

  deriveDataFromModel(): RequestData {
    // @For integration.
   console.log(this)
   
    return {
      ServiceBody :(this.data as ResponseData).ServiceBody// this.isQualifiedAccreditedInvestor}
    };
  }
  validate(){

    this.isValid = true
  }
}


@Component({
  selector: 'app-organization-information',
  templateUrl: './organization-information.component.html',
  styleUrls: ['./organization-information.component.scss'],
})
export class OrganizationInformationComponent implements OnInit {
  model = new OrganizationInformationModel(
    this.globals,
    this.apiService,
    this.el,
  );

  constructor(
    private router: Router,
    public globals: GlobalsService,
    protected apiService: ApiService,
    private modalService: NgbModal,
    private el: ElementRef,
    private sharedAPIService : SharedAPIService
  ) {

    this.model.goToNextScreen = this.goToNextScreen;
  }

  async ngOnInit() {
    this.model.purposeOfFormContentHTML = this.sharedAPIService.getDocumentPurpose();
    this.model.riskOfFormContentHTML = this.sharedAPIService.getDocumentRisk();
    this.model.noticeOfFormContentHTML = this.sharedAPIService.getDocumentNotice();
    
    await this.model.loadData();

    // To add validation for content managed modal content
    if (!this.model.hasReadPurposeOfFormModal) {
      this.showFormPurposeModal();
    }
  }

  showFormPurposeModal() {
    const modalRef = this.modalService.open(MultiStepModalComponent, {
      size: 'lg',
      backdrop: 'static',
      keyboard: false,
      scrollable: true,
    });
    modalRef.componentInstance.tncContent = this.model.purposeOfFormContent;
  }

  goToNextScreen = async () => {
    console.log('[OrganizationInformationComponent] goToNextScreen');
    await this.router.navigateByUrl('/fna/financial-situation');
  };

  goToPreviousScreen = async () => {
    console.log('[OrganizationInformationComponent] goToPreviousScreen');
    if (this.globals.model.IsOptInAccreditedInvestor === false) {
      await this.router.navigateByUrl('/fna/accredited-investor-application');
      return;
    }

    await this.router.navigateByUrl('/fna/accredited-investor');
  };
}
